import { I18n } from "@assets/strings";
import { Set } from "immutable";
import React, { useState } from "react";
import styled from "styled-components";
import { Category } from "@domain/lms/category/category";
import { useAsync } from "@utils/hooks";
import { ClosableModal } from "@ui/modals/closableModal";
import { gap } from "@ui/styles/utils";
import { createToast } from "@ui/toasts/utils";
import { LoadingButton } from "@ui/components/buttons/loadingButton";
import { CategoriesSelector } from "@ui/components/category/categoriesSelector";

interface CategoriesEditionModalProps extends React.HTMLAttributes<HTMLDivElement> {
	close: () => void;
	initialCategories: Category[];
	saveCategories: (categories: Category[]) => Promise<unknown>;
	title: string;
}
export const CategoriesEditionModal: React.FC<CategoriesEditionModalProps> = ({
	title,
	initialCategories,
	close,
	saveCategories,
	...htmlProps
}) => {
	const [categories, setCategories] = useState(Set(initialCategories));

	const { run, loading } = useAsync(() => saveCategories(categories.toArray()), [categories, saveCategories]);

	return (
		<Container title={title} close={close} {...htmlProps}>
			<CategoriesSelector selected={categories} onSelectionChange={setCategories} />
			<LoadingButton
				onClick={async () => {
					try {
						await run();
						close();
					} catch {
						createToast(I18n.t("error"), I18n.t("profile.save.error"), "error");
					}
				}}
				loading={loading}
			>
				{I18n.t("validate")}
			</LoadingButton>
		</Container>
	);
};

const Container = styled(ClosableModal)`
	${gap(24)};
	padding-left: 28px;
	padding-right: 28px;

	&& {
		max-width: 440px;
	}

	> button {
		margin: 0 auto;
	}
`;
